import { fileMetadataDisplayName } from 'conversations-visitor-message-history/attachments/model/fileMetadata';

// Wire shape returned by `livechat-public/v1/attachment/resolve/thread/{threadId}`.
// The endpoint returns a map keyed by file id string, whose values are either a
// resolved attachment (`{ fileMetadata, thumbnailMetadata }`) or `null` when the
// file could not be resolved. `fileMetadata` and `thumbnailMetadata` are sibling
// `SignedUrl`-shaped objects on the entry. See cv-threads `AttachmentResource` /
// `SignedUrl`.
// Converts a single wire `SignedUrl` into the flat `FileMetadata` fields,
// applying the historical defaults the Immutable `FileMetadataRecord` used.
function signedUrlToMetadata(signedUrl) {
  var _signedUrl$url, _signedUrl$name, _signedUrl$extension, _signedUrl$extension2, _signedUrl$type, _signedUrl$size;
  return {
    expiresAt: 0,
    url: (_signedUrl$url = signedUrl.url) !== null && _signedUrl$url !== void 0 ? _signedUrl$url : '',
    name: (_signedUrl$name = signedUrl.name) !== null && _signedUrl$name !== void 0 ? _signedUrl$name : '',
    displayName: signedUrl.name ? fileMetadataDisplayName({
      name: signedUrl.name,
      extension: (_signedUrl$extension = signedUrl.extension) !== null && _signedUrl$extension !== void 0 ? _signedUrl$extension : ''
    }) : '',
    extension: (_signedUrl$extension2 = signedUrl.extension) !== null && _signedUrl$extension2 !== void 0 ? _signedUrl$extension2 : '',
    type: (_signedUrl$type = signedUrl.type) !== null && _signedUrl$type !== void 0 ? _signedUrl$type : 'OTHER',
    fileSize: (_signedUrl$size = signedUrl.size) !== null && _signedUrl$size !== void 0 ? _signedUrl$size : 0,
    width: signedUrl.width,
    height: signedUrl.height
  };
}

// Converts a single wire entry into the plain `FileMetadata` shape consumed by
// the attachment components. Maps the whole entry — including the sibling
// `thumbnailMetadata` (used for video posters) — rather than only
// `entry.fileMetadata`. Returns `null` for entries the backend could not
// resolve so callers can filter them out.
export function signedUrlToFileMetadata(entry) {
  const metadata = entry === null || entry === void 0 ? void 0 : entry.fileMetadata;
  if (!metadata) {
    return null;
  }
  const thumbnailMetadata = entry === null || entry === void 0 ? void 0 : entry.thumbnailMetadata;
  return Object.assign({}, signedUrlToMetadata(metadata), thumbnailMetadata ? {
    thumbnailMetadata: signedUrlToMetadata(thumbnailMetadata)
  } : {});
}